import React, { useEffect, useState } from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import logo from '../../assets/logo.png';

const SECCIONES = [
  { id: 'servicios',  label: 'Servicios' },
  { id: 'proceso',    label: 'Cómo trabajamos' },
  { id: 'precios',    label: 'Precios' },
  { id: 'faq',        label: 'FAQ' },
  { id: 'contacto',   label: 'Contacto' },
];

const Header = () => {
  const [scrolled, setScrolled]   = useState(false);
  const [expanded, setExpanded]   = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const irA = (id) => {
    setExpanded(false);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <Navbar
      fixed="top"
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      style={{
        background: scrolled ? 'rgba(12, 18, 32, 0.97)' : 'rgba(12, 18, 32, 0.85)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: scrolled ? '1px solid rgba(46,139,192,0.25)' : '1px solid transparent',
        padding: scrolled ? '6px 0' : '14px 0',
        transition: 'all 0.4s ease',
        boxShadow: scrolled ? '0 4px 20px rgba(0,0,0,0.4)' : 'none',
      }}
    >
      <Container>
        <Navbar.Brand
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}
        >
          <img
            src={logo}
            alt="W"
            style={{
              height: scrolled ? '36px' : '46px',
              width: 'auto',
              transition: 'height 0.4s ease',
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
            <span style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 700,
              fontSize: scrolled ? '1.05rem' : '1.2rem',
              color: '#ffffff',
              transition: 'font-size 0.4s ease',
              letterSpacing: '-0.3px',
            }}>
              Web Fácil
            </span>
            <span style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 500,
              fontSize: scrolled ? '0.68rem' : '0.75rem',
              color: '#3ea0d7',
              letterSpacing: '1.5px',
              textTransform: 'uppercase',
              transition: 'font-size 0.4s ease',
            }}>
              Castellón
            </span>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          style={{ border: '1px solid rgba(46,139,192,0.4)', padding: '7px 10px', background: 'transparent' }}
        >
          <i className="fa-solid fa-bars" style={{ color: '#e8edf5', fontSize: '1.1rem' }} />
        </Navbar.Toggle>

        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto align-items-lg-center gap-lg-1">
            {SECCIONES.map(({ id, label }) => (
              <Nav.Link
                key={id}
                onClick={() => irA(id)}
                style={{
                  color: '#c8d8ec',
                  fontWeight: 500,
                  fontSize: '0.93rem',
                  fontFamily: 'var(--font-body)',
                  padding: '8px 14px',
                  borderRadius: '8px',
                  transition: 'color 0.2s',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => e.currentTarget.style.color = '#ffffff'}
                onMouseLeave={e => e.currentTarget.style.color = '#c8d8ec'}
              >
                {label}
              </Nav.Link>
            ))}
            <button
              onClick={() => irA('contacto')}
              className="btn-accent-custom ms-lg-2"
              style={{ padding: '10px 24px', fontSize: '0.88rem', marginTop: '4px', marginBottom: '4px' }}
            >
              Pedir presupuesto
            </button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
